import { QueryClient as t } from "./chunk429.js";
import { set as n, get as s, del as i } from "./chunk430.js";
const u = (e) => e ? new t(e) : new t({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1e3,
      gcTime: 1e3 * 60 * 60 * 24,
      retry: 3
    }
  }
}), m = (e = "pflmQuery") => ({
  persistClient: async (r) => {
    await n(e, r);
  },
  restoreClient: async () => await s(e),
  removeClient: async () => {
    await i(e);
  }
});
export {
  m as createIDBPersister,
  u as createQueryClient
};
